<template>
  <v-dialog v-model="dialog" persistent max-width="620" style="z-index: 1400 !important;">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        {{ $t('routes.webhookIntegrations.signingSecret') }}
        <v-btn icon variant="text" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" variant="tonal" class="mb-4">
          {{ $t('routes.webhookIntegrations.secretOneTimeWarning') }}
        </v-alert>
        <v-text-field
          :model-value="secret"
          :label="$t('routes.webhookIntegrations.signingSecret')"
          readonly
          variant="solo-filled"
          flat
          append-inner-icon="mdi-content-copy"
          @click:append-inner="copySecret"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="bg-primary" @click="copySecret">{{ $t('routes.webhookIntegrations.copySecret') }}</v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WebhookSecretDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    secret: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    async copySecret() {
      try {
        await navigator.clipboard.writeText(this.secret);
        this.$showMessage(this.$t('routes.webhookIntegrations.secretCopied'));
      } catch {
        this.$showMessage(this.$t('routes.webhookIntegrations.copyFailed'), { type: 'error' });
      }
    },
  },
}
</script>
